import { PromotionTemplate } from '@/models/promotion.model';
import { DarkCoupon, DimensionalCoupon, GiftCoupon, OutsideBoxCoupon, PurpleCoupon } from '../components/templates';

export const COUPON_TEMPLATES_COMPONENTS_MAP = {
  [PromotionTemplate.DARK]: DarkCoupon,
  [PromotionTemplate.DIMENSIONAL]: DimensionalCoupon,
  [PromotionTemplate.GIFT]: GiftCoupon,
  [PromotionTemplate.OUTSIDE_THE_BOX]: OutsideBoxCoupon,
  [PromotionTemplate.PURPLE]: PurpleCoupon,
};

export const getCouponTemplate = (templateNumber?: PromotionTemplate) =>
  COUPON_TEMPLATES_COMPONENTS_MAP[templateNumber ?? PromotionTemplate.DARK];
